import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

const messages = {
  en: {
    main_label: 'Search System',
    show_label: 'Visible',
    hide_label: 'Hidden',
    choose_label: 'Choose',
    continue_label: 'Continue',
    date_label: 'Date',
    date_format: 'MM/DD/YYYY HH:mm:ss',
    short_date_format: 'MM/DD/YY',
    medium_date_format: 'MM/DD/YYYY',
    today_label: 'Today',
    yesterday_label: 'Yesterday',
    week_label: 'Week',
    month_label: 'Month',
    auth: {
      main_label: 'Signing In',
      user_label: 'Username',
      pwd_label: 'Password',
      f_pwd_label: 'Forgotten password?',
      sign_in_label: 'Next',
      pwd_rec_label: 'Password Recovery',
      remind_label: 'Remind me',
      email_label: 'Email address',
      back_to_main_label: 'Back to sign-in page',
      create_acc_label: 'Create an account',
      or_label: 'otherwise',
      reg_label: 'Signing up'
    },
    events: {
      main_label: 'Events',
      name_label: 'Event',
      object_label: 'Object',
      no_data_label: 'No events found',
      search_label: 'Search through all items'
    },
    devices: {
      main_label: 'Devices',
      no_group_label: 'No group',
      undefined_label: 'Undefined',
      defined_label: 'Defined by',
      no_data_label: 'No data',
      phone_label: 'Phone',
      imei_label: 'IMEI',
      mode_label: 'Mode',
      name_label: 'Name',
      group_label: 'Group',
      contract_num_label: 'Contract #',
      mark_label: 'Mark',
      model_label: 'Model',
      vin_label: 'VIN',
      pts_label: 'Vehicle License',
      org_label: 'Organization',
      year_label: 'Year',
      full_name_label: 'Full Name',
      contact_num_label: 'Contact Phone',
      inst_place_label: 'Installed to',
      installer_fn_label: 'Installer Full Name',
      inst_date_label: 'Installation date',
      every_label: 'Every',
      min_label: 'min',
      hour_label: 'h',
      day_label: 'd',
      tilt_label: 'Tilt',
      motion_label: 'Motion',
      mode: {
        test_label: 'Test',
        leasing_label: 'Leasing',
        sleep_label: 'Sleep',
        tracker_label: 'Tracker',
        secure_label: 'Guard',
        search_label: 'Scan'
      },
      list: {
        search_label: 'Search device...',
        name_label: 'By name',
        imei_label: 'By imei',
        sim_label: 'By phone number',
        mode_label: 'By mode',
        not_found_label: 'Devices not found'
      },
      add: {
        main_label: 'Add new device',
        scan_qr_label: 'Scan QR-code',
        create_obj_label: 'Create object',
        request_inst_label: 'Request installation'
      },
      single: {
        main_label: 'Device',
        not_found_label: 'Device not found',
        delete_label: 'Delete device',
        control_device_label: 'Mode control',
        from_time_label: 'Time from',
        to_time_label: 'Time to',
        show_label: 'Show'
      },
      optional: {
        main_label: 'Optional',
        settings_label: 'Optional settings'
      }
    },
    language: {
      main_label: 'Language settings',
      type: {
        ru: 'Русский',
        en: 'English'
      }
    },
    reports: {
      main_label: 'Reports',
      settings_label: 'Reports settings',
      type_label: 'Type',
      objects_label: 'Objects',
      name_label: 'Report name',
      add: {
        main_label: 'Create report',
        create_label: 'Create'
      },
      edit: {
        main_label: 'Edit report',
        delete_label: 'Save'
      },
      type: {
        geo: 'Geozones',
        points: 'Points',
        offline_days: 'Offline more than 7 days'
      }
    },
    settings: {
      main_label: 'Settings',
      map_mng_label: 'Map settings',
      grp_mng_label: 'Group management',
      ch_lng_label: 'Choose language',
      nt_label: 'Notifications',
      change_pwd_label: 'Change password',
      logout_label: 'Logout',
      map: {
        objects_label: 'Objects',
        points_label: 'Points',
        type_label: 'Type',
        geozone_label: 'GeoZones',
        type: {
          osm: 'OSM Maps',
          google: 'Google Maps',
          google_terrain: 'Google Maps Terrain',
          yandex: 'Yandex.Maps'
        }
      }
    },
    unknown: {
      main_label: 'Unknown Component'
    }
  },
  ru: {
    main_label: 'Search System',
    show_label: 'Показывать',
    hide_label: 'Не показывать',
    choose_label: 'Выбрать',
    continue_label: 'Продолжить',
    date_label: 'Дата',
    date_format: 'DD/MM/YYYY HH:mm:ss',
    short_date_format: 'DD/MM/YY',
    medium_date_format: 'DD/MM/YYYY',
    today_label: 'Сегодня',
    yesterday_label: 'Вчера',
    week_label: '7 дней',
    month_label: '1 месяц',
    auth: {
      main_label: 'Авторизация',
      user_label: 'Имя пользователя',
      pwd_label: 'Пароль',
      f_pwd_label: 'Забыли пароль?',
      sign_in_label: 'Войти',
      pwd_rec_label: 'Восстановление пароля',
      remind_label: 'Напомнить',
      email_label: 'Email-адрес',
      back_to_main_label: 'Вернуться на страницу входа',
      create_acc_label: 'Создать аккаунт',
      or_label: 'или',
      reg_label: 'Регистрация'
    },
    events: {
      main_label: 'События',
      name_label: 'Событие',
      object_label: 'Объекты',
      no_data_label: 'События отсутствуют',
      search_label: 'Поиск по всем событиям'
    },
    devices: {
      main_label: 'Устройства',
      no_group_label: 'Без группы',
      undefined_label: 'Неопределено',
      defined_label: 'Определено по',
      no_data_label: 'Нет данных',
      phone_label: 'Телефон',
      imei_label: 'IMEI',
      mode_label: 'Режим',
      name_label: 'Название',
      group_label: 'Группа',
      contract_num_label: 'Номер договора',
      mark_label: 'Марка',
      model_label: 'Модель',
      vin_label: 'VIN',
      pts_label: 'ПТС/ПСМ',
      org_label: 'Название организации',
      year_label: 'Год',
      full_name_label: 'ФИО',
      contact_num_label: 'Номер телефона',
      inst_place_label: 'Установлено',
      installer_fn_label: 'ФИО установщика',
      inst_date_label: 'Дата установки',
      every_label: 'Каждые',
      min_label: 'мин',
      hour_label: 'ч',
      day_label: 'д',
      tilt_label: 'Крен',
      motion_label: 'Движение',
      mode: {
        test_label: 'Тест',
        leasing_label: 'Лизинг',
        sleep_label: 'Сон',
        tracker_label: 'Трекер',
        secure_label: 'Охрана',
        search_label: 'Поиск'
      },
      list: {
        search_label: 'Поиск...',
        name_label: 'По названию',
        imei_label: 'По imei',
        sim_label: 'По номеру телефона',
        mode_label: 'По режиму',
        not_found_label: 'Устройства не найдены'
      },
      add: {
        main_label: 'Добавить устройство',
        scan_qr_label: 'Сканировать QR-код',
        create_obj_label: 'Создать объект',
        request_inst_label: 'Заказать установку'
      },
      single: {
        main_label: 'Устройство',
        not_found_label: 'Устройство не найдено',
        delete_label: 'Удалить устройство',
        control_device_label: 'Управление режимом',
        from_time_label: 'Время от',
        to_time_label: 'Время до',
        show_label: 'Показать'
      },
      optional: {
        main_label: 'Доп. настройки',
        settings_label: 'Дополнительные настройки'
      }
    },
    language: {
      main_label: 'Настройки языка',
      type: {
        ru: 'Русский',
        en: 'English'
      }
    },
    reports: {
      main_label: 'Отчеты',
      settings_label: 'Настройки отчетов',
      type_label: 'Тип',
      objects_label: 'Объекты',
      name_label: 'Название отчета',
      add: {
        main_label: 'Создать отчет',
        create_label: 'Создать'
      },
      edit: {
        main_label: 'Редактировать отчет',
        delete_label: 'Сохранить'
      },
      type: {
        geo: 'Геозоны',
        points: 'Точки',
        offline_days: 'Оффлайн больше 7 дней'
      }
    },
    settings: {
      main_label: 'Настройки',
      map_mng_label: 'Настройки карты',
      grp_mng_label: 'Управление группами',
      ch_lng_label: 'Выбрать язык',
      nt_label: 'Уведомления',
      change_pwd_label: 'Сменить пароль',
      logout_label: 'Выйти',
      map: {
        objects_label: 'Объекты',
        points_label: 'Точки',
        type_label: 'Тип',
        geozone_label: 'Геозоны',
        type: {
          osm: 'OSM Карты',
          google: 'Google Карты',
          google_terrain: 'Google Карты Terrain',
          yandex: 'Яндекс.Карты'
        }
      }
    },
    unknown: {
      main_label: 'Неизвестная компонента'
    }
  }
}

const i18n = new VueI18n({
  locale: Vue.ls.get('lang', 'ru', String),
  fallbackLocale: ['ru', 'en'],
  messages
})

export default i18n



// WEBPACK FOOTER //
// ./src/localization/index.js